import { API_URL, getAuthHeaders } from './config';

export const notificationsService = {
    list: async (limit = 20, offset = 0) => {
        const res = await fetch(`${API_URL}/notifications?limit=${limit}&offset=${offset}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch notifications");
        return res.json();
    },
    getUnreadCount: async (): Promise<{ count: number }> => {
        const res = await fetch(`${API_URL}/notifications/unread-count`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) return { count: 0 }; // Silent fail
        return res.json();
    },
    markAsRead: async (id: number) => {
        await fetch(`${API_URL}/notifications/${id}/read`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
    },
    markAllAsRead: async () => {
        await fetch(`${API_URL}/notifications/mark-all-read`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
    }
};
